import styles from "./VirtualMeetingIcon.module.css";
import Virtual from "./Virtual_Icon.png";

/**
 * View component that displays the Virtual Meeting Icon.
 */

export function VirtualMeetingIcon() {
  return (
    <div className={styles.container}>
      <img src={Virtual} alt="Virtual Meeting Icon" className={styles.img} />
      <div className={styles.text}>Virtual</div>
    </div>
  );
}
